import React, { useContext, useEffect } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./Output.css";

// Scripts
import trincotParse from "./scripts/trincotParse";
import selectText from "./scripts/selectText";
import ClipboardJS from "clipboard";

// Material Ui
// #Transitions
import Zoom from "@material-ui/core/Zoom";

new ClipboardJS(".output__copy__button").on("success", () => {
  alert("copied!");
});

function Output() {
  const { appContext } = useContext(AppContext);
  const { toolBarOn } = appContext;
  useEffect(() => {
    if (!toolBarOn) {
      const content = document.querySelector(".textEditor").innerHTML;
      const contentParsed = trincotParse(content);
      document.querySelector(".output__content").innerText = contentParsed;
    }
  }, [toolBarOn]);

  const copyToClipboard = () => {
    // var amazingText = "Hello World! How sweet the content";
    // navigator.clipboard.writeText(amazingText);
    // alert("hello");
  };
  return !toolBarOn ? (
    <div>
      <div className="output">
        <span className="output__content"></span>
        <Zoom in={!toolBarOn} style={{ transitionDelay: "0.5s" }}>
          <button
            className="output__copy__button"
            onClick={copyToClipboard}
            data-clipboard-target=".output__content"
          >
            Copy
          </button>
        </Zoom>
      </div>
    </div>
  ) : null;
}

export default Output;
